import type { ProposalTemplateType } from 'types/proposalTemplate'

/**
 * Stable key for template library cards — must match selection / highlight state in TemplateLibraryModal.
 */
export function getProposalV2TemplateLibraryCardKey(template: ProposalTemplateType): string {
  const variant = !template.exclusive_project ? 'org' : 'project'
  const status = template.is_updated ? 'updated' : 'current'
  return `${variant}:${String(template.id)}:${status}`
}
